// YERİ: src/app/domains/website/routes.ts
// melbarrel.com vitrininin rotaları.
//
// Bu ağaç app.routes.ts'te EN SONDA bağlanır — ':lang' bir joker olduğu için
// yukarıda dursaydı '/admin' isteğini :lang='admin' diye yutardı ve panel
// erişilemez hâle gelirdi.
//
// Sıra burada da önemli: 'blog' ve 'legal' catch-all'dan ÖNCE gelmeli, yoksa
// CMS sayfa çözücüsü onları da bir sayfa slug'ı sanardı.

import { Routes } from '@angular/router';
import { langGuard } from './core/language.store';
import { WebLayout } from './layout/web-layout';

const routes: Routes = [
  {
    path: ':lang',
    component: WebLayout,
    // Dil kodunu doğrular. ':lang' aslında bir yol parçasıysa ('/pricing'),
    // varsayılan dili başına ekleyip yönlendirir ('/en/pricing') — dilsiz eski
    // bağlantılar böyle çalışmaya devam eder.
    canActivate: [langGuard],
    children: [
      {
        path: 'blog',
        loadComponent: () => import('./features/blog').then((m) => m.WebBlogList),
      },
      {
        path: 'blog/:slug',
        loadComponent: () => import('./features/blog').then((m) => m.WebBlogDetail),
      },
      {
        path: 'legal/:code',
        loadComponent: () => import('./features/legal').then((m) => m.WebLegal),
      },
      // Eski CMS kopyaları: tek kaynak AgreementTemplate (legal/…). '/privacy' platform
      // başvurularına (Meta, LinkedIn) verildi — adres çalışmaya devam etsin diye yönlendirilir.
      // Backend sitemap'te de dışarıda: WebPublicController_Meta.LegalCmsSlugs.
      { path: 'privacy', redirectTo: 'legal/privacy', pathMatch: 'full' },
      { path: 'terms', redirectTo: 'legal/terms', pathMatch: 'full' },
      // Hizmet kataloğu yayından kalktı (Mustafa 2026-10-13: ekip yalnız destek). Sayfa silinmedi,
      // Draft; eski bağlantılar ve arama sonuçları ana sayfaya düşsün.
      { path: 'services', redirectTo: '', pathMatch: 'full' },
      // Geri kalan HER ŞEY bir CMS sayfasıdır: '' (ana sayfa), 'pricing',
      // 'solutions/restaurant', 'about'… Admin'den açılan yeni bir sayfa kod
      // değişikliği olmadan hemen yayına girer.
      {
        path: '**',
        loadComponent: () => import('./features/cms-page').then((m) => m.WebCmsPage),
      },
    ],
  },

  // Dilsiz kök ('/') → langGuard'ın yönlendirmesine düşsün. ':lang' boş bir
  // segmentle eşleşmediği için burayı ayrıca yakalıyoruz.
  {
    path: '',
    pathMatch: 'full',
    canActivate: [langGuard],
    // Guard her koşulda yönlendirir; bu bileşen çizilmez ama Angular bir
    // hedef istiyor.
    loadComponent: () => import('./features/not-found').then((m) => m.WebNotFound),
  },
];

export default routes;
